import firebase from 'firebase/app'

export default {

  namespaced: true,

  state: {
    user: {},
    userAuthenticating: true,
    userLoggedIn: false,
    userNames: {},
    userNamesLoaded: false
  },

  getters: {
    isLoggedIn:(state) => {
        return state.userLoggedIn;
    },
    userId:(state) => {
      return state.user.uid;
    },
    userName:(state) => (uid) => {
      console.log(`store.getters.userName() uid ${uid}`);
      let name = state.userNames[uid] || '';
      return name;
    }
  },

  actions: {

    loginUser({commit}, user) {
      console.log(`store.actions.users.loginUser() ${user.uid}`);
      console.dir(this.$fbdb);
      let userRef = this.$fbdb.collection('users').doc(user.uid);
      // create a user data object to store in db and check against auth user data
      let authData = {
        'displayName':user.displayName,
        'email':user.email,
        'emailVerified':user.emailVerified,
        'phoneNumber':user.phoneNumber,
        'photoURL':user.photoURL,
        'refreshToken':user.refreshToken,
        'uid':user.uid,
        'creationTime':user.metadata.creationTime,
        'lastSignInTime':user.metadata.lastSignInTime,
      };
      return userRef.get()
        .then((docSnapshot) => {
          if (docSnapshot.exists) {
            // check auth data for changes
            let matched = ((u1, u2) => { // anonymous function
              for (var x in u1) {
                if (u2[x]) {
                  if (u1[x] != u2[x]) {
                    return false;
                  }
                } else {
                  return false;
                }
              }
              return true;
            })(docSnapshot.data(), authData); // compare auth data to stored user data
            // update user data if there are changes
            if (!matched) {
              return userRef.set(authData, {merge: true})
                .then(() => {
                  return userRef.get()
                    .then((docSnapshot) => {
                      let user = Object.assign({ '_id': docSnapshot.id }, docSnapshot.data());
                      commit('setUserStatus', true);
                      commit('setUser', user);
                      return Promise.resolve(user);
                    })
                })
                .catch(err => {throw(err)})
            } else {
              commit('setUserStatus', true);
              return commit('setUser', docSnapshot.data());
            }
          } else {
            return userRef.set(authData)
              .then(() => {
                return userRef.get()
                  .then((docSnapshot) => {
                    commit('setUserStatus', true);
                    return commit('setUser', docSnapshot.data());
                  })
              })
              .catch(err => {throw(err)})
          }
        });
    },

    logoutUser({commit}) {
        return this.$firebase.auth().signOut()
            .then(() => {
              console.log('store.actions.users.signOut() sign out complete...');
              commit('setUserStatus', false);
              return Promise.resolve();
            })
          .catch(err => { throw (err) })
    },

    loadUserNames({state, commit}) {
      let userRef = this.$fbdb.collection('users');
      if (state.userNamesLoaded) {
        return state.userNames;
      }
      return userRef.get()
        .then(QuerySnapshot => {
          let users = QuerySnapshot.docs.map(user => Object.assign({_id: user.id}, user.data()));
          console.log(`store.actions.users.loadUserNames() users:`);
          console.dir(users);
          let userNames = {};
          users.forEach(user => {
            if (user.email) {
              userNames[user._id] = user.displayName ? user.displayName : user.email.substr(0, user.email.indexOf('@'));
            }
          });
          commit('setUserNames', userNames);
          return Promise.resolve(userNames);
        })
        .catch(err => {throw(err)})
    },

    setUserStatus({commit}, status) {
      //console.log(`store.actions.users.setUserStatus() status [${status}]`);
      return commit('setUserStatus', status)
    },

    updateUser({commit, state}, udata) {
      console.log(`store.actions.users.updateUser()`);
      console.dir(udata);
      let userRef = this.$fbdb.collection('users').doc(this.state.users.user.uid),
        stateData = Object.assign({}, state.user),
        userData = Object.assign(stateData, udata);
      return userRef.set(userData)
        .then(() => {
          return userRef.get()
            .then((docSnapshot) => {
              let user = Object.assign({ '_id': docSnapshot.id }, docSnapshot.data());
              console.log(`store.actions.users.updateUser() updated user`);
              console.dir(user);
              commit('setUser', user);
              return Promise.resolve(user)
            })
            .catch(err => {throw(err)})
        })
        .catch(err => {throw(err)})
    },

    deleteUser({commit, dispatch}) {
      //console.log(`store.actions.users.deleteUser()`);
      let userRef = this.$fbdb.collection('users').doc(this.state.users.user.uid);
      return userRef.get()
        .then((docSnapshot) => {
          return docSnapshot.ref.delete()
            .then(() => {
              commit('deleteUser');
              let stats = this.$fbdb.collection('users').doc('statistics');
              stats.set({'userCount': this.$decrement})
                .then(() => {
                  return dispatch('incrementUserCount', -1)
                })
                .catch(err => {throw(err)})
            })
        })
        .catch(err => {throw(err)})
    },

    incrementUserCount(val) {
        // update postcard count
        let statsRef = this.$fbdb.collection('postcards').doc('statistics');
        let increment = firebase.firestore.FieldValue.increment(val);
        return statsRef.update({'userCount': increment})
            .then(() => {
                return statsRef.get()
                    .then((docSnapshot) => {
                        let stats = docSnapshot.data();
                        console.log(`store.actions.postcards.incrementUsersCount() postcard count #${stats.postcardCount} incremented by ${val}`);
                        return Promise.resolve(true);
                    })
                    .catch(err => { throw (err) })
            })
            .catch(err => { throw (err) })
    },

  },

  mutations: {
    setUser(state, user) {
      //console.log('store.mutations.users.setUser()');
      state.user = user;
      state.userAuthenticating = false
    },
    setUserStatus(state, status) {
      //console.log(`store.mutations.users.setUserStatus(${status})`);
      state.userLoggedIn = status;
      state.userAuthenticating = false
    },
    setUserNames(state, userNames) {
      state.userNames = userNames;
      state.userNamesLoaded = true;
    },
    deleteUser(state) {
      console.log(`store.mutations.users.deleteUser() ${state.user._id}`);
    }
  }

}
